import { ClockInPage } from "@/pages/ClockIn";

export const ClockInGate = ({
  onClockedIn,
  reason,
}: {
  onClockedIn: () => void;
  reason: "entrada" | "overtime";
}) => {
  return (
    <div className="min-h-svh w-screen bg-zinc-100 dark:bg-zinc-950 text-black dark:text-zinc-100">
      <ClockInPage onSuccess={onClockedIn} blockReason={reason} />
    </div>
  );
};
